import { useState } from 'react';

export default function useHealthPlanRequirements(
	getHealthPlanRequirementsQuery: any,
) {
	const [page, setPage] = useState(1);
	const getHealthPlanRequirements = (filter: object) => {
		getHealthPlanRequirementsQuery({
			where: { type: 'requirement', ...filter },
			pagination: { take: 20, skip: (page - 1) * 20 },
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getHealthPlanRequirements, getNextPage, page, setPage };
}
